import React, { useEffect, useState } from "react";
import VendorDetailsLeft from "./VendorDetailsLeft";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { projectFirestore } from "../../firebase-config/config";
import { Modal } from "react-bootstrap";
import format from "date-fns/format";
import { useParams } from "react-router-dom";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

// IMPORT CSS
import "./PGVendorRegistration.scss";

import VendorDetailsEmpDetails from "./VendorDetailsEmpDetails";
import VendorDocDetails from "./VendorDocDetails";
import VendorBankDetails from "./VendorBankDetails";
import VendorAddressDetails from "./VendorAddressDetails";
import VendorContactDetails from "./VendorContactDetails";

const PGVendorRegistration = () => {
  const { vendorProfileId } = useParams();

  const { user } = useAuthContext();

  // get and update code start
  const { document: vendorDetailsDoc } = useDocument(
    "organisations",
    vendorProfileId
  );

  const { updateDocument } = useFirestore("organisations");
  // get and update code end

  // get user
  const { documents: dbUsers, error: dbuserserror } = useCollection("users");
  const [dbUserState, setdbUserState] = useState(dbUsers);

  const [vendorDetailsCompletion, setVendorDetailsCompletion] = useState({
    empDetails: false,
    // docDetails: false,
    bankDetails: false,
    businessAddress: false,
    communicationAddress: false,
    // contactDetails: false,
  });

  const allSectionsComplete = Object.values(vendorDetailsCompletion).every(
    (v) => v === true
  );

  // Make sure that vendorDetailsDoc is not null before using it
  const [status, setStatus] = useState(vendorDetailsDoc?.status || "active");
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // Function to handle status changes (active/inactive)
  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    setShowPopup(true);
    setPopupData({ status: newStatus });
  };

  // Add a state to track the error message
  const [errorForNoSelectReasonMessage, setErrorForNoSelectReasonMessage] =
    useState("");

  // Function to handle the submission of the status change
  const handlePopupSubmit = async () => {
    // Check if a reason is selected when the status is inactive
    if (popupData.status === "inactive" && !reason) {
      setErrorForNoSelectReasonMessage(
        "Please select a reason before updating the status."
      );
      return; // Don't proceed if no reason is selected
    } else {
      setErrorForNoSelectReasonMessage(""); // Clear error message when a reason is selected
    }

    setLoading(true);
    try {
      const currentDate = new Date();

      const updateData = {
        status: popupData.status,
        activeBy: popupData.status === "active" ? user.phoneNumber : null, // replace with your logic
        activeAt: popupData.status === "active" ? currentDate : null, // replace with your logic
        inactiveBy: popupData.status === "inactive" ? user.phoneNumber : null,
        inactiveAt: popupData.status === "inactive" ? currentDate : null,
        inactiveReason: popupData.status === "inactive" ? reason : null, // Add reason here
        inactiveRemark: popupData.status === "inactive" ? remark : null, // Add remark here
        isActive: popupData.status === "active" ? true : false, // replace with your logic
      };

      // Add to the 'inactiveByAt' array to track status changes
      if (popupData.status === "inactive") {
        //   // Append inactive status details to the map
        updateData.inactiveByAt = vendorDetailsDoc.inactiveByAt || [];
        updateData.inactiveByAt.push({
          inactiveBy: user.phoneNumber, // Replace with actual user who is marking inactive
          inactiveAt: currentDate, // Store the current timestamp
          inactiveReason: reason, // Add the selected reason here
          inactiveRemark: remark, // Add the remark here
        });
      }

      if (popupData.status === "active") {
        // Append active status details to the map
        updateData.activeByAt = vendorDetailsDoc.activeByAt || [];
        updateData.activeByAt.push({
          activeBy: user.phoneNumber, // Replace with actual user who is marking active
          activeAt: currentDate, // Store the current timestamp
        });
      }

      // Call function to update the document in the database (replace this with your update logic)
      await updateDocument(vendorProfileId, updateData);
      setShowPopup(false);
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setLoading(false);
    }
  };
  // code for active inactive end

  // START CODE FOR CHANGE APPROVAL STATUS
  // Function to handle approval status changes (Approved / Rejected / In Review)
  const handleApprovalStatusChange = async (newStatus) => {
    setLoading(true);
    try {
      const currentDate = new Date();

      const updateData = {
        isApproved: newStatus,
        approvedBy: newStatus === true ? user.phoneNumber : null,
        approvedAt: newStatus === true ? currentDate : null,
        rejectedBy: newStatus === false ? user.phoneNumber : null,
        rejectedAt: newStatus === false ? currentDate : null,
        inReviewBy: newStatus === "inReview" ? user.phoneNumber : null,
        inReviewAt: newStatus === "inReview" ? currentDate : null,
      };

      // track history
      if (newStatus === true) {
        updateData.approvedByAt = vendorDetailsDoc.approvedByAt || [];
        updateData.approvedByAt.push({
          approvedBy: user.phoneNumber,
          approvedAt: currentDate,
        });
      }

      if (newStatus === false) {
        updateData.rejectedByAt = vendorDetailsDoc.rejectedByAt || [];
        updateData.rejectedByAt.push({
          rejectedBy: user.phoneNumber,
          rejectedAt: currentDate,
        });
      }

      if (newStatus === "inReview") {
        updateData.inReviewByAt = vendorDetailsDoc.inReviewByAt || [];
        updateData.inReviewByAt.push({
          inReviewBy: user.phoneNumber,
          inReviewAt: currentDate,
        });
      }

      await updateDocument(vendorProfileId, updateData);
      setShowPopup(false);
    } catch (error) {
      console.error("Error updating approval status:", error);
    } finally {
      setLoading(false);
    }
  };

  // END CODE FOR CHANGE APPROVAL STATUS

  const submitForm = async () => {
    if (!allSectionsComplete) {
      setSnackbarMessage("Please fill all required fields!");
      setSnackbarOpen(true);
      return;
    }

    try {
      let organisationId = vendorDetailsDoc?.organisationId;

      if (!organisationId || organisationId.trim() === "") {
        // Get first 3 letters of organisation name
        const orgName = vendorDetailsDoc?.organisationName || "";
        const prefix = orgName.substring(0, 3).toLowerCase();

        // Get total document count in "organisations" collection
        const orgsCollection = await projectFirestore
          .collection("organisations")
          .get();
        const count = orgsCollection.size;

        // Generate ID: prefix + "100" + count
        organisationId = `${prefix}100${count + 1}`;
      }

      // Update vendor document with organisationId and set isApproved to "inReview"
      await updateDocument(vendorProfileId, {
        isApproved: "inReview",
        organisationId: organisationId,
      });

      setSnackbarMessage("Submitted successfully!");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating profile status:", error);
      setSnackbarMessage("Failed to submit. Try again.");
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false); // Close snackbar
  };

  return (
    <div className="user-details-page-parent-div">
      <div className="user-details-page-parent-div-container">
        <div className="user-details-page-parent-div-layout">
          <VendorDetailsLeft vendorProfileId={vendorProfileId} />
          {/* START RIGHT SIDE */}
          <div className="profile-detail">
            <div className="pd-cards animate-slide-in">
              <div className="pd-info">
                <div style={{ width: "100%" }} className="info-heading">
                  <div>
                    <label>On-boarded</label>
                    <p>
                      {vendorDetailsDoc?.createdAt
                        ? format(
                            vendorDetailsDoc.createdAt.toDate(),
                            "dd-MMM-yyyy"
                          )
                        : ""}
                    </p>
                  </div>
                  <div>
                    <label>Recent Login</label>
                    <p>
                      {vendorDetailsDoc && vendorDetailsDoc.lastLoginTimestamp
                        ? format(
                            vendorDetailsDoc.lastLoginTimestamp.toDate(),
                            "dd-MMM-yyyy hh:mm a"
                          )
                        : ""}
                    </p>
                  </div>
                  {/* <div className="status">
                    <div className="theme_radio_container">
                      <div className="radio_single">
                        <label htmlFor="unlocked">
                          <div className="label_inner">
                            {vendorDetailsDoc
                              ? vendorDetailsDoc.isApproved === true
                                ? "Approved"
                                : vendorDetailsDoc.isApproved === false
                                ? "Rejected"
                                : vendorDetailsDoc.isApproved === "inReview"
                                ? "In Review"
                                : vendorDetailsDoc.isApproved === ""
                                ? null
                                : "Unknown"
                              : null}
                          </div>
                        </label>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="info-detail d-flex justify-content-between">
                  <div className="status">
                    {/* START CODE FOR CHANGE STATUS */}
                    <div>
                      {user && ["admin", "superAdmin"].includes(user.role) ? (
                        <>
                          <div className="theme_radio_container">
                            <div className="radio_single">
                              <input
                                type="radio"
                                id="active"
                                name="user_status"
                                value="active"
                                checked={
                                  vendorDetailsDoc &&
                                  vendorDetailsDoc.isActive === true
                                }
                                onChange={() => handleStatusChange("active")}
                              />
                              <label htmlFor="active">
                                <div className="label_inner">
                                  {vendorDetailsDoc &&
                                  vendorDetailsDoc.isActive === true
                                    ? "Active"
                                    : "Make Active"}

                                  {vendorDetailsDoc &&
                                    vendorDetailsDoc.activeBy &&
                                    vendorDetailsDoc.activeAt && (
                                      <div className="info_icon">
                                        <span className="material-symbols-outlined">
                                          info
                                        </span>
                                        <div className="info_icon_inner">
                                          <b className="text_green">Active</b>
                                          by
                                          <b>
                                            {vendorDetailsDoc &&
                                              dbUserState &&
                                              dbUserState.find(
                                                (user) =>
                                                  user.id ===
                                                  vendorDetailsDoc.activeBy
                                              )?.fullName}
                                          </b>
                                          on
                                          <b>
                                            {vendorDetailsDoc &&
                                              format(
                                                vendorDetailsDoc.activeAt.toDate(),
                                                "dd-MMM-yyyy hh:mm a"
                                              )}
                                          </b>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </label>
                            </div>
                            <div className="radio_single">
                              <input
                                type="radio"
                                id="inactive"
                                name="user_status"
                                checked={
                                  vendorDetailsDoc &&
                                  vendorDetailsDoc.isActive === false
                                }
                                onChange={() => handleStatusChange("inactive")}
                              />
                              <label htmlFor="inactive">
                                <div className="label_inner">
                                  {vendorDetailsDoc &&
                                  vendorDetailsDoc.isActive === false
                                    ? "Inactive"
                                    : "Make Inactive"}

                                  {vendorDetailsDoc &&
                                    vendorDetailsDoc.inactiveAt &&
                                    vendorDetailsDoc.inactiveBy && (
                                      <div className="info_icon">
                                        <span className="material-symbols-outlined">
                                          info
                                        </span>
                                        <div className="info_icon_inner">
                                          <b className="text_red">Inactive</b>
                                          by
                                          <b>
                                            {vendorDetailsDoc &&
                                              dbUserState &&
                                              dbUserState.find(
                                                (user) =>
                                                  user.id ===
                                                  vendorDetailsDoc.inactiveBy
                                              )?.fullName}
                                          </b>
                                          on
                                          {vendorDetailsDoc &&
                                            format(
                                              vendorDetailsDoc.inactiveAt.toDate(),
                                              "dd-MMM-yyyy hh:mm a"
                                            )}
                                          , Reason
                                          {vendorDetailsDoc &&
                                            vendorDetailsDoc.inactiveReason &&
                                            vendorDetailsDoc.inactiveReason}
                                          {/* {vendorDetailsDoc &&
                                      vendorDetailsDoc.inactiveRemark && (
                                        <>
                                          
                                          Remark
                                          <b>{vendorDetailsDoc.inactiveRemark}</b>
                                        </>
                                      )} */}
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </label>
                            </div>
                          </div>
                          <Modal
                            show={showPopup}
                            onHide={() => setShowPopup(false)}
                            centered
                          >
                            <Modal.Header
                              className="justify-content-center"
                              style={{
                                border: "none",
                                backgroundColor: "#f0f5ff",
                              }}
                            >
                              <h5>
                                {popupData.status === "inactive"
                                  ? "Reason For Inactivity"
                                  : "Confirmation"}
                              </h5>
                            </Modal.Header>
                            <Modal.Body
                              className="text-center"
                              style={{ fontSize: "18px" }}
                            >
                              {popupData.status === "inactive" && (
                                <div
                                  className="form_container"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "20px",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <div
                                    className="radio_group"
                                    style={{
                                      display: "grid",
                                      alignItems: "center",
                                      textAlign: "left",
                                    }}
                                  >
                                    <div className="radio_single">
                                      <input
                                        type="radio"
                                        name="reason"
                                        value="Security Concerns"
                                        checked={reason === "Security Concerns"}
                                        onChange={() =>
                                          setReason("Security Concerns")
                                        }
                                        id="SecurityConcerns"
                                      />
                                      <label
                                        htmlFor="SecurityConcerns"
                                        style={{ padding: "2px" }}
                                      >
                                        Security Concerns
                                      </label>
                                    </div>
                                    <div className="radio_single">
                                      <input
                                        type="radio"
                                        name="reason"
                                        value="Policy Violations"
                                        checked={reason === "Policy Violations"}
                                        onChange={() =>
                                          setReason("Policy Violations")
                                        }
                                        id="PolicyViolations"
                                      />
                                      <label
                                        htmlFor="PolicyViolations"
                                        style={{ padding: "2px" }}
                                      >
                                        Policy Violations
                                      </label>
                                    </div>
                                    {vendorDetailsDoc && (
                                      <div className="radio_single">
                                        <input
                                          type="radio"
                                          name="reason"
                                          value="Resigned"
                                          checked={reason === "Resigned"}
                                          onChange={() => setReason("Resigned")}
                                          id="Resigned"
                                        />
                                        <label
                                          htmlFor="Resigned"
                                          style={{ padding: "2px" }}
                                        >
                                          Resigned
                                        </label>
                                      </div>
                                    )}
                                    <div className="radio_single">
                                      <input
                                        type="radio"
                                        name="reason"
                                        value="Other"
                                        checked={reason === "Other"}
                                        onChange={() => setReason("Other")}
                                        id="Other"
                                      />
                                      <label
                                        htmlFor="Other"
                                        style={{ padding: "2px" }}
                                      >
                                        Other
                                      </label>
                                    </div>
                                  </div>

                                  <div
                                    className="textarea_container"
                                    style={{
                                      display: "flex",
                                      justifyContent: "right",
                                    }}
                                  >
                                    <textarea
                                      value={remark}
                                      onChange={(e) =>
                                        setRemark(e.target.value)
                                      }
                                      placeholder=" Enter any remark..."
                                      style={{ width: "250px" }}
                                    ></textarea>
                                  </div>
                                </div>
                              )}
                              <span style={{ color: "rgb(250, 98, 98)" }}>
                                Are you sure you want to mark this user as
                                {popupData.status}?
                              </span>
                            </Modal.Body>
                            <Modal.Footer
                              className="d-flex justify-content-between"
                              style={{
                                border: "none",
                                gap: "15px",
                              }}
                            >
                              {errorForNoSelectReasonMessage && (
                                <div
                                  style={{
                                    fontSize: "15px",
                                    padding: "4px 15px",
                                    borderRadius: "8px",
                                    background: "#ffe9e9",
                                    color: "red",
                                    width: "fit-content",
                                    margin: "auto",
                                  }}
                                >
                                  {errorForNoSelectReasonMessage}
                                </div>
                              )}
                              <div
                                className="cancel_btn"
                                onClick={handlePopupSubmit}
                                disabled={loading}
                                style={{ cursor: "pointer" }}
                              >
                                <button className="theme_btn">
                                  {loading ? "Saving..." : "Yes, Update"}
                                </button>
                              </div>
                              <div
                                className="done_btn"
                                onClick={() => setShowPopup(false)}
                                style={{ cursor: "pointer" }}
                              >
                                <button className="theme_btn">No</button>
                              </div>
                            </Modal.Footer>
                          </Modal>
                        </>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <h6
                            style={{ fontSize: "0.875rem", fontStyle: "bold" }}
                          >
                            Current status -
                          </h6>
                          <p style={{ fontSize: "1rem", color: "#3f5e98" }}>
                            {vendorDetailsDoc?.status ?? "None"}
                          </p>
                        </div>
                      )}
                    </div>
                    {/* END CODE FOR CHANGE STATUS */}
                  </div>
                  {/* START CODE FOR CHANGE APPROVAL STATUS */}
                  <div className="status">
                    <div>
                      {user && ["admin", "superAdmin"].includes(user.role) ? (
                        <div className="theme_radio_container">
                          <div className="radio_single">
                            <input
                              type="radio"
                              id="approved"
                              name="approval_status"
                              value="approved"
                              checked={vendorDetailsDoc?.isApproved === true}
                              onChange={() => handleApprovalStatusChange(true)}
                            />
                            <label htmlFor="approved">
                              <div className="label_inner">
                                {vendorDetailsDoc?.isApproved === true
                                  ? "Approved"
                                  : "Make Approved"}
                              </div>
                            </label>
                          </div>

                          <div className="radio_single">
                            <input
                              type="radio"
                              id="rejected"
                              name="approval_status"
                              value="rejected"
                              checked={vendorDetailsDoc?.isApproved === false}
                              onChange={() => handleApprovalStatusChange(false)}
                            />
                            <label htmlFor="rejected">
                              <div className="label_inner">
                                {vendorDetailsDoc?.isApproved === false
                                  ? "Rejected"
                                  : "Make Rejected"}
                              </div>
                            </label>
                          </div>

                          <div className="radio_single">
                            <input
                              type="radio"
                              id="inReview"
                              name="approval_status"
                              value="inReview"
                              checked={
                                vendorDetailsDoc?.isApproved === "inReview"
                              }
                              onChange={() =>
                                handleApprovalStatusChange("inReview")
                              }
                            />
                            <label htmlFor="inReview">
                              <div className="label_inner">
                                {vendorDetailsDoc?.isApproved === "inReview"
                                  ? "In Review"
                                  : "Mark as In Review"}
                              </div>
                            </label>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{ display: "flex", gap: "5px" }}
                          className="d-flex align-items-center"
                        >
                          <h6
                            style={{
                              fontSize: "0.875rem",
                              fontStyle: "bold",
                            }}
                          >
                            Approval status -
                          </h6>
                          <p style={{ fontSize: "1rem", color: "#3f5e98" }}>
                            {vendorDetailsDoc?.isApproved === true
                              ? "Approved"
                              : vendorDetailsDoc?.isApproved === false
                              ? "Rejected"
                              : vendorDetailsDoc?.isApproved === "inReview"
                              ? "In Review"
                              : "No status"}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* END CODE FOR CHANGE APPROVAL STATUS */}
                </div>
              </div>
            </div>
            {/* Vendor Details card */}
            {user && user && (
              <VendorDetailsEmpDetails
                vendorProfileId={vendorProfileId}
                onComplete={(isComplete) =>
                  setVendorDetailsCompletion((prev) => ({
                    ...prev,
                    empDetails: isComplete,
                  }))
                }
              />
            )}
            {/* Vendor Document details */}
            {user && user && (
              <VendorDocDetails vendorProfileId={vendorProfileId} />
            )}
            {/* Vendor Bank Detail card */}
            {user && user && (
              <VendorBankDetails
                vendorProfileId={vendorProfileId}
                onComplete={(isComplete) =>
                  setVendorDetailsCompletion((prev) => ({
                    ...prev,
                    bankDetails: isComplete,
                  }))
                }
              />
            )}
            {/* Business Address  */}
            {user && user && (
              <VendorAddressDetails
                title="Business Address"
                type="businessAddress"
                vendorProfileId={vendorProfileId}
                onComplete={(isComplete) =>
                  setVendorDetailsCompletion((prev) => ({
                    ...prev,
                    businessAddress: isComplete,
                  }))
                }
              />
            )}
            {/* Communcation Address  */}
            {user && user && (
              <VendorAddressDetails
                title="Communication Address"
                type="communicationAddress"
                vendorProfileId={vendorProfileId}
                onComplete={(isComplete) =>
                  setVendorDetailsCompletion((prev) => ({
                    ...prev,
                    communicationAddress: isComplete,
                  }))
                }
              />
            )}
            {/* Contact Details  */}
            {user && user && (
              <VendorContactDetails vendorProfileId={vendorProfileId} />
            )}

            {vendorDetailsDoc?.isApproved === "" && (
              <button
                // disabled={!allSectionsComplete}
                className={`btn_fill ${!allSectionsComplete ? "disabled" : ""}`}
                onClick={submitForm}
              >
                Submit
              </button>
            )}
            {vendorDetailsDoc?.isApproved == "inReview" && (
              <button className="btn_border">In Review...</button>
            )}
            {vendorDetailsDoc?.isApproved == true && (
              <button className="btn_border" style={{ cursor: "none" }}>
                Approved
              </button>
            )}
          </div>

          {/* END RIGHT SIDE */}
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{
            width: "120%",
            backgroundColor: "#ddbcf7",
            color: `var(--click-color)`,
          }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default PGVendorRegistration;
